import { EmployeeRequests } from '@/store/share-now-pass/share-now-pass.model';
import { Http } from '@pirates/not-morty-biz';
import { Offers } from './share-now-pass.types';

export class ShareNowPassService {
  public async getOffers(refCompanyId: number, legalEntityId: number) {
    return Http.get<Offers[]>(`/api/b2b/data-broker/v1/customer/companies/${refCompanyId}/subscription-offers/${legalEntityId}`);
  }

  public async getSubscriptions(refCompanyId: number) {
    return Http.get<object[]>(`/api/b2b/data-broker/v1/customer/companies/${refCompanyId}/subscriptions`);
  }

  public async getEmployeeRequests(refCompanyId: number, activationId: string, customerIds: number[]) {
    const params = new URLSearchParams();
    customerIds.forEach((i) => params.append('customerId', i.toString()));
    return Http.get<EmployeeRequests[]>(`/api/b2b/data-broker/v1/customer/companies/${refCompanyId}/subscriptions/${activationId}/activations?${params}`);
  }
}

export const shareNowPassService = new ShareNowPassService();
